module.exports = __webpack_public_path__ + "media/images/shared/conversation-8cda28e9b177af2019b8c4ba0b2f4da963de92838f4b8b464755fc5274facb8f.png";